import { Button } from "@/components/ui/button";
import { Phone, ChevronDown } from "lucide-react";
import { useState, useEffect } from "react";
import heroBg from "@/assets/hero-bg.jpg";

export const Hero = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [currentText, setCurrentText] = useState(0);
  const texts = ["Imprezę firmową", "Event integracyjny", "Galę firmową"];

  useEffect(() => {
    const phoneInterval = setInterval(() => setShowPhone(prev => !prev), 3000);
    const textInterval = setInterval(() => setCurrentText(prev => (prev + 1) % texts.length), 4000);
    return () => { clearInterval(phoneInterval); clearInterval(textInterval); };
  }, []);

  const scrollToContactForm = () => {
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center text-white overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={heroBg} alt="Scena kabaretowa - profesjonalne występy komediowe dla firm" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 animated-gradient opacity-40" />
      </div>

      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-[500px] h-[500px] bg-accent/10 rounded-full -top-40 -right-40 blur-3xl animate-float" />
        <div className="absolute w-[600px] h-[600px] bg-accent-warm/8 rounded-full -bottom-60 -left-60 blur-3xl animate-float" style={{ animationDelay: "1.5s" }} />
      </div>

      <div className="container relative z-10 text-center px-4 py-20">
        <div className="inline-block mb-6 px-4 py-2 rounded-full glass text-sm font-medium tracking-wider uppercase animate-fade-in">
          🎭 Profesjonalne występy kabaretowe
        </div>
        
        <h1 className="font-montserrat text-5xl md:text-7xl lg:text-8xl font-black mb-8 leading-tight animate-fade-in" style={{ animationDelay: "0.2s" }}>
          Rozbaw swoją<br />
          <span className="gradient-text">
            {texts[currentText]}!
          </span>
        </h1>

        <p className="font-inter text-lg md:text-xl text-white/60 mb-12 max-w-2xl mx-auto animate-fade-in" style={{ animationDelay: "0.4s" }}>
          Występy kabaretowe dla firm, które bawią, integrują
          i pozostają w pamięci na długo
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: "0.6s" }}>
          <Button 
            size="lg" 
            onClick={scrollToContactForm}
            className="bg-accent text-accent-foreground hover:bg-accent/90 text-lg px-8 py-6 rounded-full font-bold w-[240px] flex items-center justify-center gap-2 shadow-lg shadow-accent/25 hover:shadow-accent/40 transition-all duration-300 hover:scale-105"
          >
            {showPhone ? (
              <>
                <Phone className="w-5 h-5" />
                +48 533 333 993
              </>
            ) : (
              "Zamów kabaret"
            )}
          </Button>
          <Button 
            size="lg"
            variant="outline"
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
            className="border-white/20 text-white hover:bg-white/10 hover:text-white text-lg px-8 py-6 rounded-full font-semibold bg-white/10 backdrop-blur-sm"
          >
            Dowiedz się więcej
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/30" />
      </div>
    </div>
  );
};
